export const legalAgreementIds = {
  baa: 'BAA_20201015',
  plOct022023: 'PL_20231002',
  plOct052023: 'PL_20231005',
  rxDFHendUSJun2024: 'RxDFHend_20240618',
  rxDFHendUSMay2021: 'RxDFHend_20210506',
  rxDFHendUSAug2021: 'RxDFHend_20210825',
  rxDFHendCASept2021: 'RxDFHend_CA_20210901',
} as const

const agreementNames: Record<string, string> = {
  BAA_20201015: 'Business Associate Agreement 2021',
  PL_20231002: 'Private Label Agreement (October 02, 2023)',
  PL_20231005: 'Private Label Agreement (October 05, 2023)',
  RxDFHend_20210506: 'RxDFHend Agreement (May 2021)',
  RxDFHend_20210825: 'RxDFHend Agreement (August 2021)',
  RxDFHend_20240618: 'RxDFHend Agreement (last updated June 18, 2024)',
  RxDFHend_CA_20210901: 'RxDFHend Agreement (September 2021)',
}

export const displayNameForAgreementId = (agreementId: string): string =>
  agreementNames[agreementId] || agreementId
